<template>
  <section class="octobus__section tickets">
    <template  v-if="tickets.length !== 0">
      <div
        class="noprint"
        :class="{ 'octobus__container': !isFullWidth }"
      >
        <div class="octobus__columns content">
          <div class="octobus__column has-text-centered is-size-4">{{$t('tickets.title')}}</div>
        </div>
      </div>
      <div
        class="is-hidden-mobile noprint"
        :class="{ 'octobus__container': !isFullWidth }"
      >
        <div
          class="octobus__columns trips-menu has-text-weight-light is-uppercase is-size-6-tablet"
          @click.prevent="setSorting">
          <div class="octobus__column" data-sort="dtDepSec">
            <span data-sort="dtDepSec">{{$t('tickets.departure')}}</span>
            <font-awesome-icon
              :icon="getArrow('dtDepSec')"
              data-sort="dtDepSec"
              :class="{'is-active': isActiveSort('dtDepSec')}"
            />
          </div>
          <div class="octobus__column" data-sort="wayTimeSec">
            <span data-sort="wayTimeSec">{{$t('tickets.inway')}}</span>
            <font-awesome-icon
              :icon="getArrow('wayTimeSec')"
              data-sort="wayTimeSec"
              :class="{'is-active': isActiveSort('wayTimeSec')}"
            />
          </div>
          <div class="octobus__column" data-sort="dtArrSec">
            <span data-sort="dtArrSec">{{$t('tickets.arrived')}}</span>
            <font-awesome-icon
              :icon="getArrow('dtArrSec')"
              data-sort="dtArrSec"
              :class="{'is-active': isActiveSort('dtArrSec')}"
            />
          </div>
          <div class="octobus__column" data-sort="place">
            <span data-sort="place">{{$t('tickets.place')}}</span>
            <font-awesome-icon
              :icon="getArrow('place')"
              data-sort="place"
              :class="{'is-active': isActiveSort('place')}"
            />
          </div>
          <div class="octobus__column" data-sort="price">
            <span data-sort="price">{{$t('tickets.price')}}</span>
            <font-awesome-icon
              :icon="getArrow('price')"
              data-sort="price"
              :class="{'is-active': isActiveSort('price')}"
            />
          </div>
        </div>
      </div>
      <Ticket
        :trip="ticket"
        v-for="ticket in tickets"
        :key="ticket.tripId"
        inline-template
        @printTicket="printTicket"
        @showRfund="onShowRefund"
      >
        <div class="ticket noprint octobus__box" :class="{'is-loading': loading.link, 'octobus__container': !isFullWidth}">
          <div class="octobus__columns">
            <div class="octobus__column">
              <p class="persona">{{ trip.name }} {{trip.lastName}}</p>
            </div>
          </div>
          <div class="octobus__columns">
            <div class="octobus__column">
              <div class="is-inline-block-touch time-block">
                <span class="time-departure is-block-touch has-text-weight-bold">
                  {{ trip.dtDep | time }}
                </span>
                <span class="date-departure is-block-touch">
                  {{ trip.dtDep | date}}
                </span>
              </div>
              <div class="is-inline-block-touch address-block">
                <span class="city-departure is-block-touch">
                  {{ trip.stDepName}}
                </span>
                <span class="address-departure is-block-touch">
                  {{ trip.stDepAddr}}
                </span>
              </div>
            </div>
            <div class="octobus__column duration-block">
              <div class="is-inline-block-touch trip-arrow-div time-block is-size-4 is-hidden-tablet">
                <font-awesome-icon :icon="arrowDownLong" />
              </div>
              <div class="is-inline-block-touch has-text-weight-bold">
                <span class="time-inway">
                  {{$t('ticket.inway', {wayTimeH: trip.wayHour, wayTimeM: trip.wayMin})}}
                </span>
              </div>
              <div class="is-inline-block-touch has-text-weight-bold">
                <ChangeBus
                  :forward="route.forward.length"
                  :backward="route.backward.length"
                />
              </div>
            </div>
            <div class="octobus__column">
              <div class="is-inline-block-touch time-block">
                <span class="time-arrived is-block-touch has-text-weight-bold">
                  {{ trip.dtArr | time}}
                </span>
                <span class="date-arrived is-block-touch">
                  {{ trip.dtArr | date}}
                </span>
              </div>
              <div class="is-inline-block-touch address-block">
                <span class="city-arrived is-block-touch">
                  {{ trip.stArrName}}
                </span>
                <span class="address-departure is-block-touch">
                  {{ trip.stArrAddr}}
                </span>
              </div>
            </div>
            <div class="octobus__column">
              <div class="is-inline-block-touch time-block"></div>
              <div class="is-inline-block-touch">
                <span class="is-hidden-tablet">{{$t('ticket.free')}}</span>
                <span class="places">{{ trip.place}}</span>
              </div>
            </div>
            <div class="octobus__column">
              <div class="octobus__columns is-mobile has-text-weight-bold has-text-primary is-vcentered">
                <div class="octobus__column">
                  {{ trip.price }} {{ trip.curr }}
                </div>
              </div>
            </div>
          </div>
          <div class="octobus__columns is-vcentered">
            <div class="octobus__column is-three-fifths has-text-centered-mobile is-size-7 has-text-weight-light">
              <p class="carrier">{{$t('ticket.carrier', {carrier: trip.carrierName})}}</p>
            </div>
          </div>
          <div class="octobus__columns">
            <div class="octobus__column is-one-fifths">
              <p @click="downloadTicket" class="octobus__download">
                <font-awesome-icon :icon="downloadIcon" />
                <span>{{$t('tickets.download')}}</span>
              </p>
            </div>
            <div class="octobus__column is-three-fifths">
              <p @click="printTicket" class="octobus__print">
                <font-awesome-icon :icon="printIcon" />
                <span>{{$t('tickets.print')}}</span>
              </p>
            </div>
            <div class="octobus__column">
              <p @click="cancelTicket" class="octobus__cancel" v-if="trip.canRefund === 1 && !trip.refundReq">
                <font-awesome-icon :icon="cancelIcon" />
                <span>{{$t('tickets.cancel')}}</span>
              </p>
              <p class="octobus__cancel in-progress" v-if="trip.canRefund === 1 && trip.refundReq">
                <span>{{$t('tickets.inProgress')}}</span>
              </p>
            </div>
          </div>
        </div>
      </Ticket>
    </template>
    <div :class="{ 'octobus__container': !isFullWidth }" v-else>
      <p class="">{{$t('tickets.empty')}}</p>
    </div>
    <template v-if="isPrinting">
      <Boarding
        :ticket="boardingTicket.bl[0]"
        :createdAt="boardingTicket.createdAt"
        :bookingExpiresAt="boardingTicket.bookingExpiresAt"
        :orderNum="boardingTicket.orderNum"
        :sum="boardingTicket.sum"
        :reserve="boardingTicket.dateRes && !boardingTicket.bl[0].paidAt"
        :locale="locale"
        @ticketMounted="onPrint"
        class="prepere-for-print"
      />
    </template>
    <Refund
      v-if="showModal === true"
      :show="showModal === true"
      :refundData="refundData"
      @hideModal="onHide"/>
  </section>
</template>

<script>
import moment from 'moment';
import api from '@/api';
import orderBy from 'lodash/orderBy';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import { faSortDown, faSortUp } from '@fortawesome/fontawesome-free-solid';
import Ticket from './Ticket/Ticket';
import Boarding from './BoardingTicket/Boarding';
import Refund from './_common/Refund';

export default {
  name: 'Tickets',
  components: {
    Ticket,
    FontAwesomeIcon,
    Boarding,
    Refund,
  },
  data() {
    return {
      tickets: [],
      loading: {
        trips: true,
      },
      sorting: {
        field: 'price',
        type: 'asc',
      },
      boardingTicket: {},
      isPrinting: false,
      showModal: false,
      refundData: {},
      locale: this.$framelocale,
    };
  },
  filters: {
    date(value) {
      return moment(value).format('DD MMMM');
    },
  },
  methods: {
    async printTicket(buyid) {
      try {
        const ticket = await api.Buy.buysite({ buyid, copy: 1 });

        this.boardingTicket = ticket;
        this.isPrinting = true;
      } catch (e) {
        throw e;
      }
    },
    onPrint() {
      this.isPrinting = false;
      window.print();
    },
    onHide() {
      this.showModal = false;
    },
    onShowRefund(data) {
      this.refundData = data;
      this.showModal = true;
    },
    isActiveSort(field) {
      if (field === this.sorting.field) {
        return true;
      }

      return false;
    },
    getArrow(field) {
      if (field === this.sorting.field && this.sorting.type === 'desc') {
        return faSortUp;
      }

      return faSortDown;
    },
    setSorting(event) {
      const { sort } = event.target.dataset;

      if (sort === this.sorting.field) {
        this.sorting.type = this.sorting.type === 'asc' ? 'desc' : 'asc';
      } else {
        this.sorting.field = sort;
        this.sorting.type = 'desc';
      }
      this.tickets = orderBy(this.tickets, obj => parseFloat(obj[this.sorting.field]), this.sorting.type);
    },
    async getTickets() {
      this.loading.trips = true;
      const { id } = this.$userData || this.$EventBus.$userData;
      const tickets = await api.Content.buyertickets(id);

      for (let i = 0; i < tickets.length; i += 1) {
        tickets[i].dtDepSec = Date.parse(tickets[i].dtDep);
        tickets[i].dtArrSec = Date.parse(tickets[i].dtArr);
        tickets[i].wayTimeSec = ((tickets[i].wayHour * 60) * 60) + (tickets[i].wayMin * 60);
      }

      this.tickets = orderBy(tickets, obj => parseFloat(obj[this.sorting.field]), this.sorting.type);
      this.loading.trips = false;
    },
  },
  computed: {
    isFullWidth() {
      return this.$fullwidth;
    },
  },
  mounted() {
    this.getTickets();
    this.$EventBus.$on('refund:done', this.getTickets);
  },
  beforeDestroy() {
    this.$EventBus.$off('refund:done', this.getTickets);
  },
};
</script>

<style lang="scss" scoped>
#app {
  .tickets {
    .trips-menu {
      margin-bottom: 1rem;
      margin-left: 1.25rem;

      .octobus__column {
        cursor: pointer;

        .fa-sort-down {
          vertical-align: top;
        }

        .fa-sort-up {
          vertical-align: bottom;
        }

        .fa-sort-up,
        .fa-sort-down {
          color: #808080;

          &.is-active{
            color: $color-main;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Tickets.vue